import { useMemo } from 'react';
import { useI18n } from 'Hooks/useI18n';
import {
    AMPLIFIER_COMPLIANCE_TRAINING_ACTION_TEMPLATES_I18N_KEY,
    parseAmplifierComplianceTrainingActionTemplatesFromI18n,
} from 'Core-utils/i18n/amplifierTrainingTemplateI18n';
import {
    AmplifierTrainingTemplateDefinition,
    buildAmplifierTrainingTemplateStubs,
    mergeAmplifierTrainingTemplates,
} from './amplifierTrainingTemplates';

export const useAmplifierTrainingTemplates = () => {
    const { t, loading } = useI18n();
    const templatesI18nRaw = t(AMPLIFIER_COMPLIANCE_TRAINING_ACTION_TEMPLATES_I18N_KEY, '[]');

    const templates = useMemo((): AmplifierTrainingTemplateDefinition[] => {
        const copyByKey = parseAmplifierComplianceTrainingActionTemplatesFromI18n(templatesI18nRaw);
        return mergeAmplifierTrainingTemplates(copyByKey);
    }, [templatesI18nRaw]);

    const stubs = useMemo(() => buildAmplifierTrainingTemplateStubs(templates), [templates]);

    return { templates, stubs, loading };
};
